<template>
  <container-page>
    <bloc-simple class="p-3 mb-3 rounded" style="min-width:300px;">
      <h5>Gestion des véhicules</h5>
      <div>
        <router-link
          to="/vehicules/liste"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
          >Listes des véhicules</router-link
        >
        <router-link
          to="/vehicules/indicateurs"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
          >Indicateurs véhicules</router-link
        >
        <router-link
          to="/vehicules/indicateurs-entretiens"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
        >
          Indicateurs entretiens
        </router-link>
        <router-link
          to="/vehicules/indicateurs-equipements"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
        >
          Indicateurs équipements
        </router-link>
        <router-link
          to="/vehicules/indicateurs-sinistres"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
        >
          Indicateurs sinistres
        </router-link>
        <router-link
          to="/vehicules/indicateurs-contraventions"
          class="mt-1 cursor-pointer"
          :active-class="activeClass"
          :class="hoverClass"
          tag="div"
        >
          Indicateurs contraventions
        </router-link>
      </div>
    </bloc-simple>
    <div>
      <div class="d-flex align-items-center" v-if="loading">
        <loader class="m-5"></loader>
        <h2 class="m-0">Chargement...</h2>
      </div>
    </div>
    <div class="flex-grow-1" v-if="!loading">
      <router-view></router-view>
    </div>
  </container-page>
</template>
<script>
import ContainerPage from "@/components/containers/ContainerPage.vue";
import BlocSimple from "@/components/containers/ContainerBloc.vue";
import Loader from "@/components/bases/Loader.vue";

export default {
  components: {
    ContainerPage,
    BlocSimple,
    Loader
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    //this.getAll();
    //this.getData();
  },
  methods: {},
  computed: {
    activeClass: function() {
      if (!this.$store.getters["isDarkMode"]) {
        return "stroke-red text-danger";
      } else {
        return "stroke-red text-primary";
      }
    },
    hoverClass: function() {
      if (!this.$store.getters["isDarkMode"]) {
        return "cursor-hover-light";
      } else {
        return "cursor-hover-dark";
      }
    }
  }
};
</script>
<style></style>
